import makeStyles from '@mui/styles/makeStyles';
import { SourcesCheckboxesProps } from './AutomationFields/SourcesCheckboxes';

export const useStyles = makeStyles((theme) => ({
  accordionDetails: {
    flexDirection: 'column',
  },
  accordionHeading: {
    fontWeight: 500,
    fontSize: 16,
  },
  wrapperAccordions: {
    marginTop: 32,
  },
  wrapperAutomationFields: {
    marginTop: -16,
  },
  root: {
    '& > div:nth-child(1)': {
      width: '100% !important',
      '& figure': {
        '& div:nth-child(2)': {
          width: '100% !important',
        },
      },
    },
  },
  weekDays: {
    '& .react-autosuggest__container': {
      position: 'relative',
      width: '100%',
    },
  },
  suggestionStyle: {
    position: 'absolute',
    width: '100%',
    zIndex: 10,
    '& > ul': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
  },
  label: {
    transform: 'scale(0.75)',
  },
  switchContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  spacingTop: {
    marginTop: 16,
  },
  checkboxesContainer: {
    color: (props?: Pick<SourcesCheckboxesProps, 'disabled'>) =>
      props?.disabled ? theme.palette.text.disabled : 'inherit',
    marginTop: 16,

    '& .MuiList-root': {
      paddingTop: '0',
    },

    '& .MuiListItem-root': {
      paddingLeft: '0 !important',
      pointerEvents: (props?: Pick<SourcesCheckboxesProps, 'disabled'>) =>
        props?.disabled ? 'none' : 'initial',

      '& .MuiIconButton-label': {
        color: (props?: Pick<SourcesCheckboxesProps, 'disabled'>) =>
          props?.disabled ? theme.palette.grey[400] : 'inherit',
      },
    },

    '& .MuiCheckbox-colorSecondary.Mui-checked ': {
      color: theme.palette.primary.main,
    },
  },
  sourceCodeTextField: {
    marginTop: 32,
    padding: 0,

    '& textarea': {
      fontFamily: 'monospace',
      fontSize: '14px',
      minHeight: 120,
      padding: 26,
      tabSize: 2,
    },
    '& legend': {
      position: 'relative',
      padding: '0 5px',
      top: '-7px',
      visibility: 'visible',

      '& span': {
        fontSize: '12px',
        padding: 0,
      },

      '& svg': {
        fontSize: '20px',
        position: 'relative',
        top: '-2px',
      },

      '& span, & svg': {
        verticalAlign: 'middle',
      },
    },

    '&.Mui-focused label': {
      color: theme.palette.primary.main,
    },

    '&.Mui-error label, &.Mui-error fieldset': {
      borderColor: `${theme.palette.error.main} !important`,
      color: theme.palette.error.main,
    },
  },
  withoutAnalyticsRadios: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: '-12px',
  },
  grid: {
    padding: theme.spacing(2),
    width: '100%',
  },
}));
